import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { Input } from "../../../components/core/Input";
import { PrimaryButton } from "../../../components/others/ButtonPrimary";
import Select from "../../../components/others/Select/Select";
import LavorisService from "../../../services/LavorisService";
import { individualEntities } from "../../../services/publicData/PublicData.type";
import { PhoneNumber } from "../../../components/others/PhoneNumber";
import StyledWrapper from "./style";
import { CircularProgress } from "@mui/material";
import { useAlert } from "../../../hooks/useAlert";
import { getErrorMessage } from "../../../utils";
import { InputEmail } from "../../../components/others/InputEmail";
import InputRadio from "../../../components/others/InputRadio/InputRadio";

type TProps = {
  handleClose: Function;
};

export default function UpdateContact({ handleClose }: TProps) {
  //useState
  const [searchParams, setSearchParams] = useSearchParams("");
  const [isLoading, setIsLoading] = useState(false);
  const [contactsPositionsValues, setContactsPositionsValues] =
    useState<individualEntities>([{ name: "", value: "" }]);
  const [isReady, setReady] = useState(false);
  const { showAlert } = useAlert();


  const { register, handleSubmit, reset: resetValues, setValue, formState: { errors }, control, } = useForm<any>({ mode: "all" });
  const LavorisInstance = LavorisService.getInstance();

  const getPublicData = async () => {
    await LavorisInstance.PublicData.getPublicData()
      .then((res) => {
        setContactsPositionsValues(res.contactsPositions);
      })
      .catch((error) => console.log(error));
  };



  let contactID: any = searchParams.get("rowId");

  const getContactData = async () => {
    await LavorisInstance.CompanyServices.getOneContact(contactID)
      .then((res) => {
        //console.log("res", res)
        resetValues({
          ...res,
          lastname: res.fullname.split(',')[0],
          name: res.fullname.split(',')[1],
          phoneNumber: res.phone_number,
          billingEmailEnabled: res.billing_email_enable ? 'Si' : 'No',
        })
        for (let [key, value] of Object.entries(res)) {
          let name: any = key;
          switch (name) {
            case "position":
              // Si value es un objeto, extraer el alias
              if (value && typeof value === "object" && "alias" in value) {
                setValue("position", value.alias);
              }
              // Si value es un string, mantener la lógica anterior para compatibilidad
              else if (typeof value === "string") {
                if (value === "Administración") {
                  setValue("position", "ADMIN");
                }
                if (value === "Contador") {
                  setValue("position", "ACCOUNTANT");
                }
                if (value === "Gerente RRHH") {
                  setValue("position", "HR_HEAD");
                }
                if (value === "Comunicación") {
                  setValue("position", "COMUNICACION");
                }
                if (value === "RRHH") {
                  setValue("position", "HR");
                }
                if (value === "Marketing") {
                  setValue("position", "MARKETING");
                }
                if (value === "Ventas") {
                  setValue("position", "VENTAS");
                }
                if (value === "Compras") {
                  setValue("position", "COMPRAS");
                }
                if (value === "Otro") {
                  setValue("position", "OTHER");
                }
              }
              break;
            case "company":
              // Si value es un objeto, extraer el id si es necesario
              if (value && typeof value === "object" && "id" in value) {
                // Si necesitas usar el companyId en el formulario, descomenta la siguiente línea
                // setValue("companyId", value.id);
              }
              break;
            case "updated_user_name":
              // Este campo puede ser null, no necesita procesamiento
              break;
          }
        }


      })
      .catch((error) => console.log(error));

  };

  // useEffects
  useEffect(() => {
    const getData = async () => {
      await getContactData();
      await getPublicData();
      setReady(true)
    }

    getData()

  }, []);

  const onSubmit = async (data: any) => {
    setIsLoading(true);
    const updateData = {
      email: data.email,
      phoneNumber: data.phoneNumber,
      company_id: data.company.id,
      position: data.position,
      contact_id: data.id,
      billingEmailEnabled: data.billingEmailEnabled === 'Si' ? true : false,
      created_user_name: data.created_user_name,
      name: `${data.lastname.trim()},${data.name.trim()}`,
    };

    try {
      await LavorisInstance.CompanyServices.updateContact(updateData);
      handleClose?.();
    } catch (err) {
      console.log(err);
      showAlert(getErrorMessage({ title: 'Error al editar el contacto', err }))
    } finally {
      setIsLoading(false);
    }
  };

  if (!isReady) return <CircularProgress color="error" size={15} />;

  return (
    <div className="w-full h-full">
      <form onSubmit={handleSubmit(onSubmit)}>
        <StyledWrapper.FormContainer>
          <Input
            type="text"
            label="Apellido"
            fieldName="lastname"
            register={register}
            required
            error={errors?.lastname}
          />
          <Input
            type="text"
            label="Nombre"
            fieldName="name"
            register={register}
            required
            error={errors?.name}
          />


          <Select
            fieldName="position"
            label="Puesto en la empresa"
            options={contactsPositionsValues}
            register={register}
            required
            error={errors?.position}
            styles="rounded w-full h-[50px]"
          />

          <PhoneNumber
            label="Teléfono"
            fieldName="phoneNumber"
            control={control}
            error={errors?.phoneNumber}
            required
          />

          <InputEmail
            label="E-Mail"
            nameInput="email"
            register={register}
            required
            error={errors}
          />

          <InputRadio
            label="¿Habilitado para recibir emails de facturación?"
            fieldName="billingEmailEnabled"
            option1="Si"
            option2="No"
            register={register}
            //required
            error={errors?.billingEmailEnabled}
            globalContainerStyles="mt-5"
          />
          <div className="flex gap-6">
            <PrimaryButton
              type="submit"
              text="Guardar cambios"
              styles="bg-red-500 font-bold text-white mt-8"
              disabled={isLoading}
            />
          </div>
        </StyledWrapper.FormContainer>
      </form>
    </div>
  );
}
